import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
import moment from "moment";
import { IRecibo } from '../../../shared/services/api/ProducaoService';

async function ImpRecibos(dados: IRecibo[], texto: string) {
    pdfMake.vfs = pdfFonts.pdfMake.vfs;

    const numero = require('numero-por-extenso');

    const documentDefinition: any = {
        pageSize: 'A4',
        pageMargins: [40, 50, 20, 50],
        pageOrientation: 'portrait',
        content: [
            dados.map((e) => {
                 return [
                   [ 
                      
                        [
                            {
								table: {
                                    widths: [230, 130, 130],
									body: [
										[ {text: 'Recibo', fontSize: 20, alignment: 'center', },
                                          {text: 'Valor\n'+ new Intl.NumberFormat('pt-br', {minimumFractionDigits: 2}).format(e.total) , fontSize: 18, alignment: 'center', }, 
                                          {text: 'Data\n '+ moment(e.dataproducao).format("DD/MM/YYYY"), fontSize: 18, alignment: 'center', },
                                        ],
                                        [
                                            {
                                                 colSpan: 3,
                                                 text: 'Recbi : '+e.produtor,
                                                 heights: 10,
                                            },
                                        ],
                                        [
                                            {   colSpan: 1,
                                                text: 'CEI: '+e.numero,
                                                margin: [0, 5, 0, 5],
                                                heights: 10,
                                            },
                                            {   colSpan: 2,
                                                text: 'Inscrição Estadual: Isento',
                                                margin: [0, 5, 0, 5],
                                                heights: 10,
                                            },
                                    
                                        ],
                                        [
                                            {  
                                                colSpan: 3,
                                                text: 'a importância de: '+numero.porExtenso(e.total, numero.estilo.monetario).toUpperCase(),
                                                heights: 10,
                                            },
                                    
                                        ],   
                                        [
                                            {  
                                                colSpan: 3,
                                                text: 'Referente a '+new Intl.NumberFormat('pt-br', {minimumFractionDigits: 2}).format(e.quantidade) +' Sacos de Café Colhidos',
                                                heights: 10,
                                            },
                                    
                                        ],
                                        [
                                           
                                            {
                                                colSpan: 3,
                                                table: {
                                                    widths: [200, 245],
                                                    body: [
                                                         [{
                                                            // border: [false, false, false, false],
                                                            table: {
                                                                widths: [80, 50],
                                                                body: [
                                                                    [
                                                                     {text:'Sub-Total' , border: [false, false, false, false],}, 
                                                                     {text: new Intl.NumberFormat('pt-br', {minimumFractionDigits: 2}).format(e.subtotal), alignment: 'right', border: [false, false, false, false]} 
                                                                    ],
                                                                    [
                                                                     {text:'Adiantamento', border: [false, false, false, false],}, 
                                                                     {text: new Intl.NumberFormat('pt-br', {minimumFractionDigits: 2}).format(e.desconto), alignment: 'right', border: [false, false, false, false],}],
                                                                    [
                                                                     {text:'Total Geral', border: [false, false, false, false],}, 
                                                                     {text: new Intl.NumberFormat('pt-br', {minimumFractionDigits: 2}).format(e.total), alignment: 'right', border: [false, false, false, false],}
                                                                    ],                                                                  
                                                                ]
                                                            },
                                                            border: [false, false, false, false],
                                                         },
                                                         
                                                         
                                                         {
                                                            table: {
                                                                widths: [285],
                                                                body: [
                                                                    [
                                                                     {text:'Pelo Que Dou Plena e Geral Quitação', alignment: 'center' }, 
                                                                    ],
                                                                    [
                                                                     {text: 'Nome..: '+e.nome, border: [true, false, true, false]} 
                                                                    ],
                                                                    [
                                                                     {text: 'Local.: Eunapólis', border: [true, false, true, false],}
                                                                    ],      
                                                                    [
                                                                     {text: 'CPF...: '+e.cpf, border: [true, false, true, true],}
                                                                    ],                                                               
                                                                ]
                                                            },
                                                            border: [false, false, false, false],
                                                        }
                                                        
                                                     ],
                                                    ]
                                                },
                                                border: [true, false, true, false],

                                            },   
                                            
                                        ],
                                        [
                                            {  
                                                colSpan: 3,
                                                text: '___________________________________ \n'+e.nome,  alignment: 'center',  margin: [0, 50, 0, 30],
                                                heights: 10,
                                                fontSize: 10,
                                                border: [true, false, true, false],
                                           },
                                        ],
                                        [
                                            {  
                                                colSpan: 3,
                                                text: 'Por ser expressão de verdade, dou quitação pela importância recebida, firmando o presente recibo nesta data.',
                                                heights: 10,
                                                fontSize: 9,
                                                border: [true, false, true, true],
                                           },
                                        ],
                                        [
                                            {   
                                                text:'',
                                                colSpan: 3,
                                                border: [false, false, false, false],
                                                heights: 10,
                                           },
                                        ],
                                        [
                                            {   
                                                text:'',
                                                colSpan: 3,
                                                border: [false, false, false, false],
                                                heights: 10,
                                           },
                                        ],
                                        [
                                            {   
                                                text:'',
                                                colSpan: 3,
                                                border: [false, false, false, false],
                                                heights: 10,
                                           },
                                        ],
                                        [
                                            {   
                                                text:'',
                                                colSpan: 3,
                                                border: [false, false, false, false],
                                                heights: 10,
                                           },
                                        ],
                                        [
                                            {   
                                                text:'',
                                                colSpan: 3,
                                                border: [false, false, false, false],
                                                heights: 10,
                                           },
                                        ],
									]
								},
							}
                                                 
                        ]
                    ]                           
                
                ]
            }
           ) 
        ]
    }

  const pdfDocGenerator = pdfMake.createPdf(documentDefinition);
  pdfDocGenerator.open();

}

export default ImpRecibos;